import { useContext, useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap"; // Import Bootstrap Modal components
import { CartContext } from "./CartContext";
import "./css/QuantityBtn.css";

export default function QuantityBtn({ productInfo, user }) {
  const { cartItems, setCartItems } = useContext(CartContext);

  let productIndexInCart = cartItems.findIndex((element) => {
    return element.id === productInfo.id;
  });

  let [numInCart, setNumInCart] = useState(
    productIndexInCart === -1 ? 0 : cartItems[productIndexInCart].quantity
  );

  useEffect(() => {
    const savedCartItems = localStorage.getItem(`${user}_cartItems`);
    if (savedCartItems) {
      setCartItems(JSON.parse(savedCartItems));
    }
  }, [user, setCartItems]);

  const handleAdd = () => {
    let newCartItems;
    if (productIndexInCart === -1) {
      newCartItems = [
        {
          id: productInfo.id,
          商品名稱: productInfo.商品名稱,
          img: productInfo.img,
          售價: productInfo.售價,
          產品特色: productInfo.產品特色,
          quantity: 1,
        },
        ...cartItems,
      ];
      setCartItems(newCartItems);
    } else {
      let newCartArray = [...cartItems];
      newCartArray[productIndexInCart].quantity++;
      newCartItems = newCartArray;
      setCartItems(newCartItems);
    }
    localStorage.setItem(`${user}_cartItems`, JSON.stringify(newCartItems));
    setNumInCart(numInCart + 1);
  };

  const handleSubtract = () => {
    let newCartItems;
    if (cartItems[productIndexInCart].quantity === 1) {
      let newCartArray = [...cartItems];
      newCartArray.splice(productIndexInCart, 1);
      newCartItems = newCartArray;
      setCartItems(newCartItems);
    } else {
      let newCartArray = [...cartItems];
      newCartArray[productIndexInCart].quantity--;
      newCartItems = newCartArray;
      setCartItems(newCartItems);
    }
    localStorage.setItem(`${user}_cartItems`, JSON.stringify(newCartItems));
    setNumInCart(numInCart - 1);
  };

  const [showModal, setShowModal] = useState(false);

  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);

  return (
    <>
    {(numInCart === 0) ? (
        <Button variant="primary" onClick={handleShowModal}>
        加入購物車
      </Button>
    ) : ( <Button variant="primary" onClick={handleShowModal}>
        數量 {numInCart}
      </Button>)}
     

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>調整數量</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="addToCart">
          
            <div>
                {/* 讀取 productDetail 並且顯示 productDetail.度數 的資料 */}
                <h4>度數: {productInfo.度數}</h4>
            </div>
            <div class="input-group mb-3">
              <button
                className="subtractBtn"
                style={{
                  width: "50px",
                  fontWeight: "bold",
                  fontSize: "20px",
                  backgroundColor: "#244e7e",
                }}
                type="button"
                onClick={handleSubtract}
              >
                -
              </button>
              <input
                    type="number" // 設置為 number
                    className="form-control text-center"
                    style={{ fontWeight: "bold", fontSize: "20px" }}
                    placeholder=""
                    aria-label="Example text with two button addons"
                    value={numInCart}
                    onChange={(e) => {
                        const newValue = parseInt(e.target.value); // 將輸入值轉換為整數
                        if (!isNaN(newValue)) { // 確保是有效的數字
                            setNumInCart(newValue);
                        }
                    }}
                />


              <button
                className="addBtn"
                style={{
                  width: "50px",
                  fontWeight: "bold",
                  fontSize: "20px",
                  backgroundColor: "#244e7e",
                }}
                type="button"
                onClick={handleAdd}
              >
                +
              </button>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            關閉
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
